import { assertUnreachable } from '@dreryk/react-common';

import {
   DetailQuestionViewModel,
   FieldScope,
   MedicalProfileTabFormController,
} from '../../tab/MedicalProfileTab.types';

import { MultiChoiceField } from './MultiChoiceField';
import { NumberField } from './NumberField';
import { SingleChoiceField } from './SingleChoiceField';
import { TextField } from './TextField';

type DetailQuestionFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly question: DetailQuestionViewModel;
   readonly disabled: boolean;
   readonly scope?: FieldScope;
};

export const DetailQuestionField = (props: DetailQuestionFieldProps): JSX.Element | null => {
   const fieldProps = {
      register: props.register,
      templateCode: props.templateCode,
      question: props.question,
      disabled: props.disabled,
      scope: props.scope,
   };

   switch (props.question.answerType) {
      case 'SINGLE_CHOICE':
         return <SingleChoiceField {...fieldProps} />;
      case 'MULTI_CHOICE':
         return <MultiChoiceField {...fieldProps} />;
      case 'TEXT':
         return <TextField {...fieldProps} />;
      case 'NUMBER':
         return <NumberField {...fieldProps} />;
      case 'DATE':
      case 'DATE_RANGE':
      case 'CODED':
      case 'MULTI_CODED':
         // TODO DREGAB-29796: render the remaining answer types once they are required by the medical profile templates
         return null;
      default:
         return assertUnreachable(props.question.answerType);
   }
};
